import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, useParams } from "react-router-dom";
import AuthenticationRoutes from "./routes/AuthenticationRoutes.js";
import { ToastContainer } from "react-toastify";
import UnAuthenticationRoutes from "./routes/UnAuthenticationRoutes.js";
import { useSelector } from "react-redux";

const App = () => {

  const { email, token } = useSelector(state => state.userState);

  console.log()
  return (
    <>
      <ToastContainer />
      <Router>

        {/* {email &&  */}
        {token ?
          <AuthenticationRoutes />
          :
          <UnAuthenticationRoutes />}
      </Router>

      {/*  <Signin/>  */}
    </>
  );
};

export default App;
